import AuthService from '@/packages/auth-service'
import store from '@/app/store'
import b2bApiClient from '@/shared/api/b2b-client'

export class ApiKeyService {
  constructor() {
    this.client = b2bApiClient.getClient()
  }

  get _accessToken() {
    return store.state.auth.access_token || AuthService.getAccessToken()
  }

  get _headers() {
    return {
      'Content-Type': 'application/json',
      'x-access-token': this._accessToken,
    }
  }

  async createApiKey(formData) {
    return await this.client.post(`/auth/keys`, formData, {
      headers: this._headers,
    })
  }

  async updateApiKey(formData) {
    return await this.client.client
      .patch('/auth/keys', formData, {
        headers: this._headers,
      })
      .then((res) => Promise.resolve(res.data))
      .catch(this.client._parseError)
  }

  async getApiKeys(params) {
    return await this.client.get('/auth/keys', params, this._headers)
  }

  async deleteApiKey(key) {
    return await this.client.delete(`/auth/keys/${key}`, {
      headers: this._headers,
    })
  }
}

export const apiKeyService = new ApiKeyService()
export default apiKeyService
